import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import SidebarContainer from '../../components/@container/sidebar-container';
import WholesalePartsHubSidebar from '../../components/@wholesale-parts-hub/wholesale-parts-hub-sidebar';
import BackToTop from '../../components/back-to-top';
import CertifiedCollision from '../../components/certified-collision';

const WholesalePartsCenterCertifiedCollision: NextPage = () => (
  <Layout title="Certified Collision" omit={true}>
    <SidebarContainer
      sidebar={<WholesalePartsHubSidebar />}
      content={<CertifiedCollision />}
    />
    <BackToTop />
  </Layout>
);

export default WholesalePartsCenterCertifiedCollision;
